import React from 'react'
import ReactVisibilitySensor from 'react-visibility-sensor';

type SingleTapProps = {
    title : string;
    subtitle : string;
    image : {
        name : string;
        alt : string;
    },
    list : { text : string; important : boolean }[],
}

const SingleTabFour = ({ title, subtitle, image, list } : SingleTapProps) => {
  return (
    <div className="time-line-container">
        <div className="tab-col">
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
                <h3 className={`tab-title an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>{title}</h3>
            )}
            </ReactVisibilitySensor>
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
                <p className={`tab-subtitle an-move-left-fade-in an-d-2 ${isVisible ? "an-active" : ""}`}>{subtitle}</p>
            )}
            </ReactVisibilitySensor>
        </div>
        <div className="tab-col">
            <ul className="tab-list">
                {
                list.map((item, index) => (
                    <ReactVisibilitySensor 
                        key={index}
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                        <li 
                            key={index} 
                            className={`list-item an-move-left-fade-in an-d-${index} ${isVisible ? "an-active" : ""} ${item.important && "red-color"}`}
                        >
                            {item.text}
                        </li>
                    )}
                    </ReactVisibilitySensor>
                ))
                }
            </ul>
        </div>
        <div className="tab-col">
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
            <img 
                src={require(`../../../assets/images/tabs/${image.name}`)}
                alt={image.alt}
                className={`tab-image an-move-top-fade-in ${isVisible ? "an-active" : ""}`}
            />
            )}
            </ReactVisibilitySensor>
        </div>
    </div>
  )
}

export default SingleTabFour